export enum UserStatus {
    notStarted = 'notStarted',
    completed = 'completed',
}
